export default __webpack_public_path__ + "static/media/arrow-blck.c80d81e9.svg";